module.exports = __webpack_public_path__ + "img/geodesy_home.b20c3c7e.jpg";